module.exports = __webpack_public_path__ + "static/img/icon_logo.c842ba35.png";